<template>
  <div class="supervisor-reservation" :class = "{'clear-header':isWechatBrowser}">
    <my-header title="预约工长" v-if="!isWechatBrowser" :showBack="true"></my-header>
    <div class="content-form">
      <div class="appointment-form-item border-bottom-style">
        <div class="form-title">联系人</div>
        <input class="form-input" type="text" v-model="appointment.name" placeholder="请输入联系人"/>
        <div class="form-input-box-sex">
          <div class="sex-radio" @click="sexClick(1)">
            <img v-if="sexStatus == 1" src="../../assets/icon/icon-check-box-selected.png">
            <img v-if="sexStatus != 1" src="../../assets/icon/icon-check-box-unselect.png">男
          </div>
          <div class="sex-radio" @click="sexClick(0)">
            <img v-if="sexStatus == 0" src="../../assets/icon/icon-check-box-selected.png">
            <img v-if="sexStatus != 0" src="../../assets/icon/icon-check-box-unselect.png">女
          </div>
        </div>
      </div>
      <div v-if="deposit" class="appointment-form-item border-bottom-style">
        <div class="form-title">订金</div>
        <div class="appointment-deposit"><span class="unit">￥</span><span class="num">{{gangmaster.deposit}}</span></div>
      </div>
      <div class="appointment-form-item border-bottom-style" @click="selectHouseType()">
        <div class="form-title">户型</div>
        <input class="form-input" type="text" readonly v-model="houseTypeShow" placeholder="选择户型"/>
        <img class="icon-form-select" src="../../assets/icon/icon-drop-down.png">
      </div>
      <div class="appointment-form-item border-bottom-style" @click="selectArea()">
        <div class="form-title">区域</div>
        <input class="form-input" type="text" readonly v-model="areaName" placeholder="选择区域"/>
        <img class="icon-form-select" src="../../assets/icon/icon-drop-down.png">
      </div>
      <div class="appointment-form-item border-bottom-style" @click="selectHouseState()">
        <div class="form-title">房屋类型</div>
        <input class="form-input" type="text" readonly v-model="houseStateShow" placeholder="选择房屋类型"/>
        <img class="icon-form-select" src="../../assets/icon/icon-drop-down.png">
      </div>
      <div class="appointment-form-item border-bottom-style">
        <div class="form-title">面积</div>
        <input class="form-input" type="number" v-model="appointment.houseArea" placeholder="请输入平方数"/>
        <div class="form-unit">平米</div>
      </div>
      <div class="appointment-form-item border-bottom-style">
        <div class="form-title">小区</div>
        <input class="form-input" type="text" v-model="appointment.village" placeholder="请输入小区名称"/>
      </div>
      <div class="appointment-form-item border-bottom-style">
        <div class="form-title">手机号</div>
        <input class="form-input" type="number" v-model="appointment.phone" placeholder="请输入手机号"/>
      </div>
      <div class="appointment-submit-btn" :class="{'wait-res': waitRes}" @click="checkAppointment()">提交</div>
    <!--已预约是否再次预约的提示框-->
    <div v-if="alertCheck" class="toast general-tip-modal">
      <img class="close-btn" src="../../assets/icon-close-btn.png" @click="cancelAlert()">
      <div class="general-modal-title border-bottom-style">温馨提示</div>
      <div class="general-modal-msg">已预约，您要再次预约吗？</div>
      <div class="agree-btn" @click="confirmAlert()">再次预约</div>
    </div>
    <div v-if="alertCheck" class="pay-box"></div>
    <!--预约成功提示-->
    <div v-if="alertSuccess" class="toast general-tip-modal" style="height: 9rem">
      <img class="close-btn" src="../../assets/icon-close-btn.png" @click="goback()">
      <img src="../../assets/gangmaster/icon-appointment-success.png" style="width: 2.2rem;height: 2.2rem">
      <div class="general-modal-title border-bottom-style">预约成功</div>
      <div v-if="!recommendAppointmentMember">
        <div class="recommend-tip">系统为您免费智能推荐工长，无需支付订金</div>
        <div class="recommend-list">
          <div class="recommend-item" v-for="(member,index) in recommendMemberList" @click="selectRecommendMember(member.id,index)">
            <img class="avatar" :src="imgUrl+member.avatar"/>
            <div class="name">{{member.name}}</div>
            <img v-if="!member.check" class="icon-switch" src="../../assets/gangmaster/icon-uncheck.png">
            <img v-if="member.check" class="icon-switch" src="../../assets/gangmaster/icon-check.png">
          </div>
        </div>
        <div class="recommend-btns">
          <div class="btn refresh" @click="getRecommendMemberList()">换一批</div>
          <div class="btn confirm" @click="confirmRecommendAppointment()">确认</div>
        </div>
      </div>
      <div v-if="recommendAppointmentMember">
        <div class="recommend-tip" style="margin-top: 0.9rem">您预约的工长是{{supervisorName}},</div>
        <div v-if="isShowRecommendMemberName" class="recommend-tip" style="margin-top: 0.3rem">推荐的工长是{{recommendSupervisorName}}</div>
        <div class="agree-btn" @click="openAppointmentDetail()">预约详情</div>
      </div>
    </div>
    <div v-if="alertSuccess" class="pay-box"></div>
    <div v-if="showSelectArea" class="toast appointment-select-part">
      <img class="close-btn" src="../../assets/icon-close-btn.png" @click="confirmSelectArea">
      <div class="select-title" @click="confirmSelectArea">请选择区域</div>
      <div class="appointment-area-select-list">
        <div v-for="area in areaList" @click="selectAppointmentArea(area.value,area.text)"  class="select-item" :class="{selected: area.value == areaId,disable:area.disabled}">{{area.text}}</div>
      </div>
    </div>
    <div v-if="showSelectArea" class="pay-box"></div>

    <div v-if="showSelectHouseState" class="toast appointment-select-part">
      <img class="close-btn" src="../../assets/icon-close-btn.png" @click="confirmSelectHouseState">
      <div class="select-title" @click="confirmSelectHouseState">请选择房屋类型</div>
      <div class="appointment-area-select-list">
        <div v-for="houseStateItem in houseStateList" @click="selectAppointmentHouseState(houseStateItem.value,houseStateItem.text)"  class="select-item" :class="{selected: houseStateItem.value === houseState}">{{houseStateItem.text}}</div>
      </div>
    </div>
    <div v-if="showSelectHouseState" class="pay-box"></div>

    <div v-if="showSelectHouseType" class="toast appointment-select-part">
      <img class="close-btn" src="../../assets/icon-close-btn.png" @click="confirmSelectHouseType">
      <div class="select-title" @click="confirmSelectHouseType">请选择户型</div>
      <div class="appointment-select-list">
        <div class="appointment-select-group">
          <div v-for="roomType in roomTypeList" class="select-item" :class="{selected: roomType.value == room}" @click="selectRoom(roomType.value,roomType.showText)">{{roomType.text}}</div>
        </div>
        <div class="appointment-select-group">
          <div v-for="parlourType in parlourTypeList" class="select-item" :class="{selected: parlourType.value == parlour}" @click="selectParlour(parlourType.value,parlourType.showText)">{{parlourType.text}}</div>
        </div>
        <div class="appointment-select-group">
          <div v-for="toiletType in toiletTypeList" class="select-item" :class="{selected: toiletType.value == toilet}" @click="selectToilet(toiletType.value,toiletType.showText)">{{toiletType.text}}</div>
        </div>
        <div class="appointment-select-group">
          <div v-for="kitchenType in kitchenTypeList" class="select-item" :class="{selected: kitchenType.value == kitchen}" @click="selectKitchen(kitchenType.value,kitchenType.showText)">{{kitchenType.text}}</div>
        </div>
      </div>
    </div>
    <div v-if="showSelectHouseType" class="pay-box"></div>

      <!--预约温馨提示-->
      <div v-if="showAppointmentTip" class="toast general-tip-modal">
        <img class="close-btn" src="../../assets/icon-close-btn.png" @click="closeAppointmentTip()">
        <div class="general-modal-title border-bottom-style">温馨提示</div>
        <div class="reminder-content">
          <div>为了保证您的售后维修服务</div>
          <div>请您选定工长后</div>
          <div>一定要在小程序生成项目</div>
          <div>并上传合同凭证（三方协议第一页）</div>
        </div>
        <div class="agree-btn" @click="closeAppointmentTip()">已知晓</div>
      </div>
      <div v-if="showAppointmentTip" class="pay-box"></div>

      <!--预约温馨提示-->
      <div v-if="showConfirmPayTip" class="toast general-tip-modal">
        <img class="close-btn" src="../../assets/icon-close-btn.png" @click="closePayTip()">
        <div class="general-modal-title border-bottom-style">温馨提示</div>
        <div class="reminder-content">
          <div>支付完成后</div>
          <div>请点击我已付款按钮!</div>
          <div>如有问题请联系客服!  电话：4000600566</div>
        </div>
        <div class="agree-btn" @click="closeConfirmPayTip()">我已付款</div>
      </div>
      <div v-if="showConfirmPayTip" class="pay-box"></div>
    </div>
  </div>
</template>

<script>
  import {imgUrl,shareIcon} from '../../config'
  import {Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import session from '../../utils/Session'
  import AppointmentService from '../../service/customer/AppointmentService'
  import supervisorAreaService from '../../service/onestop/OnestopSupervisorAreaService'
  import AreaService from '../../service/core/AreaService'
  import SupervisorService from '../../service/SupervisorService'
  import shareService from '../../service/share/ShareService'
  import recommendMemberService from '../../service/recommend/RecommendGroupMemberService'
  import appointmentMemberService from '../../service/recommend/RecommendAppointmentGroupMemberService'
  import payUtil from '../../utils/Pay'

  export default {
    name: 'GangmasterReservation',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        sexStatus:1,
        companyId:'',
        areaName:'',
        areaId:'',
        room:'',
        roomShowText:'',
        parlour:'',
        parlourShowText:'',
        toilet:'',
        toiletShowText:'',
        kitchen:'',
        kitchenShowText:'',
        areaList:[{value:0,text:'请选择',disabled:false}],
        roomTypeList:[{value:1,text:'一室',showText:'一室'},{value:2,text:'两室',showText:'两室'},{value:3,text:'三室',showText:'三室'},{value:4,text:'四室',showText:'四室'},{value:5,text:'五室',showText:'五室'}],
        parlourTypeList:[{value:1,text:'一厅',showText:'一厅'},{value:2,text:'两厅',showText:'两厅'},{value:3,text:'三厅',showText:'三厅'},{value:4,text:'四厅',showText:'四厅'},{value:5,text:'五厅',showText:'五厅'}],
        toiletTypeList:[{value:1,text:'一卫',showText:'一卫'},{value:2,text:'两卫',showText:'两卫'},{value:3,text:'三卫',showText:'三卫'},{value:4,text:'四卫',showText:'四卫'},{value:5,text:'五卫',showText:'五卫'}],
        kitchenTypeList:[{value:1,text:'一厨',showText:'一厨'},{value:2,text:'两厨',showText:'两厨'},{value:3,text:'三厨',showText:'三厨'},{value:4,text:'四厨',showText:'四厨'},{value:5,text:'五厨',showText:'五厨'}],
        houseTypeShow:'',
        appointment:{phone:''},
        gangmaster:{},
        alertCheck:false,
        alertSuccess:false,
        recommendList:[],
        imgUrl: imgUrl,
        shareIcon:shareIcon,
        isSelectedJi:true,
        isWechatBrowser:this.$verfyBrowserType(),
        showSelectArea:false,
        showSelectHouseType:false,
        houseType:{},
        showOtherHouseType:false,
        supervisorName:'',
        appointmentedId:'',
        showSelectHouseState:false,
        houseStateList:[{value:0,text:'旧房'},{value:1,text:'新房'}],
        houseStateShow:'',
        houseState:'',
        supervisorAreaList:[],
        prePayInfo:{},
        tradeAppointmentId:'',
        deposit:'',
        waitRes:false,
        showAppointmentTip:false,
        showConfirmPayTip:false,
        recommendMemberId:[],
        recommendAppointmentMember:false,
        recommendSupervisorName:'',
        recommendMemberList:[],
        isShowRecommendMemberName:true
      }
    },
    created(){
      this.appointment.foremanId = this.$route.query.id || '';
      this.companyId = this.$route.query.companyId;
      this.supervisorName = this.$route.query.supervisorName;
      this.deposit = this.$route.query.deposit;
      this.showAppointmentTip = true;
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.initWechatShare();
      this.getSupervisorAreaList();
      this.getGangmasterInfo(this.appointment.foremanId);
    },
    methods: {
      sexClick(num){
        if(num == 1){
          this.sexStatus=1;
        }else {
          this.sexStatus=0;
        }
      },
      selectRecommendMember(id,index){
          this.recommendMemberList[index].check = !this.recommendMemberList[index].check;
      },
      async getRecommendMemberList(){
          this.recommendMemberList = [];
          var result= await recommendMemberService.get(this.appointmentedId);
          if(result.code == 0){
              console.info(result)
              if(result.data.length==0){
                  this.recommendAppointmentMember = true;
                  this.isShowRecommendMemberName = false;
              }
              for(let member of result.data){
                  this.$set(member,'check',true);
                  this.recommendMemberList.push(member);
              }
          }else {
              Toast('获取工长详细信息失败');
          }
      },
      async confirmRecommendAppointment(){
         for(let member of this.recommendMemberList){
             if(member.check){
                 this.recommendMemberId.push(member.id);
                 this.recommendSupervisorName = this.recommendSupervisorName + ',' + member.name;
             }
         }
          this.recommendSupervisorName = this.recommendSupervisorName.substr(1,this.recommendSupervisorName.length);
          var result= await appointmentMemberService.customer(this.appointmentedId,this.recommendMemberId);
          if(result.code == 0){
              this.recommendAppointmentMember = true;
          }else {
              Toast('预约推荐工长失败');
          }
      } ,
      async getGangmasterInfo(id){
          var result= await SupervisorService.getSupervisorDetail(id);
          if(result.code == 0){
            this.gangmaster = result.data;
          }else {
            Toast('获取工长详细信息失败');
          }
      },
      async getSupervisorAreaList(){
        var result = await supervisorAreaService.list(this.appointment.foremanId);
        if(result.code == 0){
          this.supervisorAreaList = result.data;
          this.getAreaList('2');
        }else {
          Toast('获取工长接单区域信息失败');
        }
      },
      async getAreaList(cityId){
        this.areaList = [];
        var result=await AreaService.getAreaList(cityId);
        if(result.code == 0){
          var areas = result.data;
          var that = this;
          $(areas).each(function () {
            this.disabled = true;
            this.value=this.id;
            this.text=this.name;
            for (let supervisorArea of that.supervisorAreaList){
              if(supervisorArea.areaId === this.id){
                this.disabled = false
              }
            }
            that.areaList.push(this);
          });
        }else {
          Toast('获取城市区域列表信息失败');
        }
      },
      /**
       * 验证手机号码（移动电话）
       */
      mobilePhone(){
        var phone = this.appointment.phone;
        if (phone == '') {
          Toast('请输入手机号码！');
          return false;
        }
        var re= /^1[3578]\d{9}$/;
        if(re.test(phone)){
          return true;
        } else {
          Toast('手机号码格式不正确!');
          return false;
        }
      },
      async initWechatShare(){
        let title = "水木家居商城工长预约入口——"+this.supervisorName;// 分享标题
        let desc = ""; // 分享描述
        let link = window.location.href; // 分享链接
        link = link.replace(/#/, '?#');
        await shareService.wechatShare(title,desc,link,this.shareIcon);
      },
      async checkAppointment(){
        var result= await SupervisorService.getSupervisorDetail(this.appointment.foremanId);
        if(result.code == 0){
          this.gangmaster = result.data;
          if(this.gangmaster.appointmentSwitch != '1'){
            Toast('该工长暂时不接受预约!');
            return;
          }else if(this.gangmaster.appointmentSwitch == '1' && this.gangmaster.spares == 0){
            Toast('该工长预约已满!');
            return;
          }
        }else {
          Toast('预约失败!');
          return
        }

        if(this.appointment.name == null || this.appointment.name == ''){
          Toast('请填写联系人姓名！');
          return;
        }
        if(this.room == '' || this.parlour == ''){
          Toast('请完善您的户型信息!');
          return;
        }
        if(this.areaId == ''){
          Toast('请选择区域！');
          return;
        }else {
          let areaSelect = false;
          for (let supervisorArea of this.supervisorAreaList){
            if(this.areaId == supervisorArea.areaId){
              areaSelect = true;
            }
          }
          if(!areaSelect){
            Toast('对不起!您选择的区域不在该工长接单范围!');
            return;
          }else {
            this.appointment.cityId = 2;
            this.appointment.areaId = this.areaId;
          }
        }
        if(this.houseState === ''){
          Toast('请选择房屋类型！');
          return;
        }
        if(this.appointment.houseArea == null || this.appointment.houseArea == ''){
          Toast('请填写住房面积！');
          return;
        }
        if(this.appointment.village == null || this.appointment.village == ''){
          Toast('请填写小区名称！');
          return;
        }
        if(!this.mobilePhone()){
          return;
        }
        this.appointment.type = 2;
        this.appointment.sex = this.sexStatus;
        this.appointment.room = this.room;
        this.appointment.parlour = this.parlour;
        this.appointment.toilet = this.toilet;
        this.appointment.kitchen = this.kitchen;
        this.appointment.houseType = this.houseState;

        if(this.companyId){
          this.appointment.companyId = this.companyId;
        }
        this.appointment.customerId = session.getAccountToken().id == undefined || session.getAccountToken().id == 'null' ? '' : session.getAccountToken().id;
        this.waitRes = true;
        var res=await AppointmentService.checkAppointment(this.appointment);
        if(res.code == '0'){
          if(res.data == '1'){
            if(this.gangmaster.deposit && this.gangmaster.deposit>0){
              this.waitRes = false;
              let prepayResult = await AppointmentService.prePayAppointment(this.appointment,this.gangmaster.deposit);
              if(prepayResult.code == '0'){
                this.tradeAppointmentId = prepayResult.data.tradeAppointmentId;
                //判断用户使用环境
                let ua = navigator.userAgent.toLowerCase();
                if(ua.match(/newsmthApp/i) == 'newsmthapp'){
                    //水木社区app
                   window.location.href = 'bridgescheme://request_shuimuPay?prepayId=' + prepayResult.data.prepayId;
                   //弹出提示业主查询支付结果弹窗
                   this.showConfirmPayTip = true;
                }else {
                    //微信中调用微信支付
                    this.prePayInfo = payUtil.pay(prepayResult.data.prepayId,prepayResult.data.nonceStr);
                    let requestPay = this.requestPay;
                    if (typeof WeixinJSBridge == "undefined"){
                        if( document.addEventListener ){
                            document.addEventListener('WeixinJSBridgeReady', requestPay.bind(this), false);
                        }else if (document.attachEvent){
                            document.attachEvent('WeixinJSBridgeReady', requestPay.bind(this));
                            document.attachEvent('onWeixinJSBridgeReady', requestPay.bind(this));
                        }
                    }else{
                        this.requestPay();
                    }
                }
              } else {
                Toast(prepayResult.msg);
              }
            }else {
              this.appointment.isDeposited = '0';
              this.createAppointment();
            }
          }else {
            this.waitRes = false;
            this.alertCheck = true;
          }
        }else {
          this.waitRes = false;
          Toast('预约失败，请稍后再试！');
        }
      },
      selectArea(){
        this.showSelectArea = true;
      },
      selectAppointmentArea(areaId,areaName){
        this.areaId = areaId;
        this.areaName = areaName;
      },
      confirmSelectArea(){
        this.showSelectArea = false;
        if(this.areaId){
            let areaSelect = false;
            for (let supervisorArea of this.supervisorAreaList){
              if(this.areaId == supervisorArea.areaId){
                areaSelect = true;
              }
            }
            if(!areaSelect){
              Toast('对不起!您选择的区域不在该工长接单范围!');
            }
        }
      },
      selectHouseState(){
        this.showSelectHouseState = true;
      },
      selectAppointmentHouseState(houseState,houseStateShow){
        this.houseState = houseState;
        this.houseStateShow = houseStateShow;
      },
      confirmSelectHouseState(){
        this.showSelectHouseState = false;
      },
      selectHouseType(){
        this.showSelectHouseType = true;
      },
      confirmSelectHouseType(){
        this.houseTypeShow = this.roomShowText + this.parlourShowText + this.toiletShowText + this.kitchenShowText;
        this.showSelectHouseType = false;
      },
      selectRoom(room,showText){
        if(this.room != room){
          this.roomShowText = showText;
          this.room = room;
        } else {
          this.roomShowText = '';
          this.room = '';
        }
      },
      selectParlour(parlour,showText){
        if(this.parlour != parlour){
          this.parlourShowText = showText;
          this.parlour = parlour;
        } else {
          this.parlourShowText = '';
          this.parlour = '';
        }
      },
      selectToilet(toilet,showText){
        if(this.toilet != toilet){
          this.toiletShowText = showText;
          this.toilet = toilet;
        } else {
          this.toiletShowText = '';
          this.toilet = '';
        }
      },
      selectKitchen(kitchen,showText){
        if(this.kitchen != kitchen){
          this.kitchenShowText = showText;
          this.kitchen = kitchen;
        } else {
          this.kitchenShowText = '';
          this.kitchen = '';
        }
      },
      cancelAlert(){
        this.alertCheck = false;
      },
      async confirmAlert(){
        this.alertCheck = false;
        if(this.gangmaster.deposit && this.gangmaster.deposit>0){
            let prepayResult = await AppointmentService.prePayAppointment(this.appointment,this.gangmaster.deposit);
            if(prepayResult.code == '0'){
                this.tradeAppointmentId = prepayResult.data.tradeAppointmentId;
                //判断用户使用环境
                let ua = navigator.userAgent.toLowerCase();
                if(ua.match(/newsmthApp/i) == 'newsmthapp'){
                    //水木社区app
                    Toast('水木社区环境');
                    window.location.href = 'bridgescheme://request_shuimuPay?prepayId=' + prepayResult.data.prepayId;
                    //弹出提示业主查询支付结果弹窗
                    this.showConfirmPayTip = true;
                }else {
                    //微信中调用微信支付
                    this.prePayInfo = payUtil.pay(prepayResult.data.prepayId,prepayResult.data.nonceStr);
                    let requestPay = this.requestPay;
                    if (typeof WeixinJSBridge == "undefined"){
                        if( document.addEventListener ){
                            document.addEventListener('WeixinJSBridgeReady', requestPay.bind(this), false);
                        }else if (document.attachEvent){
                            document.attachEvent('WeixinJSBridgeReady', requestPay.bind(this));
                            document.attachEvent('onWeixinJSBridgeReady', requestPay.bind(this));
                        }
                    }else{
                        this.requestPay();
                    }
                }
            } else {
                Toast(prepayResult.msg);
            }
        }else {
            this.appointment.isDeposited = '0';
            this.createAppointment();
        }
      },
      goback () {
        this.$router.go(-1);
      },
      openAppointmentDetail(){
        this.$router.push({name:'AppointmentDetail',query:{id:this.appointmentedId}});
      },
      async createAppointment(){
        var result = await AppointmentService.createAppointment(this.appointment);
        if(result.code == '0'){
          this.alertSuccess = true;
          this.appointmentedId = result.data.id;
          this.getRecommendMemberList()
        }else {
          Toast(result.msg);
        }
        this.waitRes = false;
      },
      requestPay(){
        let prePayInfo = this.prePayInfo;
        let that = this;
        try {
          WeixinJSBridge.invoke(
            'getBrandWCPayRequest',
            {
              "appId":prePayInfo.appId,     //公众号名称，由商户传入
              "timeStamp":prePayInfo.timeStamp,         //时间戳，自1970年以来的秒数
              "nonceStr":prePayInfo.nonceStr, //随机串
              "package":prePayInfo.package,
              "signType":prePayInfo.signType,         //微信签名方式：
              "paySign":prePayInfo.paySign //微信签名
            },
            function(res){
              if(res.err_msg == "get_brand_wcpay_request:ok" ) {
                that.appointment.tradeAppointmentId = that.tradeAppointmentId;
                that.appointment.isDeposited = 1;
                that.createAppointment();
              } else if(res.err_msg == "get_brand_wcpay_request:cancel" ){
                console.info("取消支付");
              }else {
                Toast('支付失败!');
              }// 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
            },function (e) {
              console.error("支付失败err!"+JSON.stringify(e));
              Toast("支付失败!"+JSON.stringify(e));
            });
        }catch (e){
          console.error("支付失败-----!"+JSON.stringify(e));
          Toast("支付失败!"+JSON.stringify(e));
        }
      },
      closeAppointmentTip(){
        this.showAppointmentTip = false;
      },

      async closeConfirmPayTip(){
        let result = await AppointmentService.checkPaymentStatus(this.tradeAppointmentId);
        if(result.code == '0'){
            this.appointment.tradeAppointmentId = this.tradeAppointmentId;
            this.appointment.isDeposited = 1;
            this.showConfirmPayTip = false;
            this.createAppointment();
        }else {
            Toast('请联系客服确认订单支付结果!');
        }
      },

      async closePayTip(){
          this.showConfirmPayTip = false;
          let result = await AppointmentService.checkPaymentStatus(this.tradeAppointmentId);
          if(result.code == '0'){
              this.appointment.tradeAppointmentId = this.tradeAppointmentId;
              this.appointment.isDeposited = 1;
              this.createAppointment();
          }else {
              Toast('请联系客服确认订单支付结果!');
          }
      }
    }
  }
</script>

<style lang="scss">
  @import '../../assets/style/common.scss';
  @import '../../assets/style/supervisor-appointment.scss';
  .recommend-tip{
    margin-top: 0.35rem;
    font-size: 0.32rem;
    font-weight: 600;
    color: #7f7d7c;
    letter-spacing: 1px;
  }
  .recommend-list{
    display: flex;
    justify-content: space-around;
    .recommend-item{
      .avatar{
        margin-top: 0.5rem;
        width: 1.3rem;
        height: 1.3rem;
        border-radius: 0.1rem;
        box-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.1);
      }
      .name{
        margin-top: 0.2rem;
        margin-bottom: 0.3rem;
        font-size: 0.28rem;
        font-weight: 600;
        color: #191818;
      }
      .icon-switch{
        width: 0.33rem;
        height: 0.33rem;
      }
    }
  }
  .recommend-btns{
    display: flex;
    justify-content: space-around;
    margin-top: 0.3rem;
    .btn{
      width: 1.9rem;
      height: 0.7rem;
      line-height: 0.7rem;
      color: white;
      font-size: 0.32rem;
      border-radius: 0.35rem;
    }
    .refresh{
      background-color: #70c285;
    }
    .confirm{
      background-color: #feac00;
    }
  }
</style>
